import {
  get,
  post,
  update,
} from '../helpers'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchDatas(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        get('/admin/status-jadwal-sidang', queryParams)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchData(ctx, { id }) {
      return new Promise((resolve, reject) => {
        get(`/admin/status-jadwal-sidang/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    addData(ctx, userData) {
      return new Promise((resolve, reject) => {
        post('/admin/status-jadwal-sidang/post', userData)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updateData(ctx, userData) {
      return new Promise((resolve, reject) => {
        update('/admin/status-jadwal-sidang', userData)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteData(ctx, userData) {
      return new Promise((resolve, reject) => {
        post('/admin/status-jadwal-sidang/delete', userData)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchDataRoles(ctx, { id }) {
      return new Promise((resolve, reject) => {
        get(`/admin/roles/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    addDataRoles(ctx, userData) {
      return new Promise((resolve, reject) => {
        post('/admin/roles', userData)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    removeDataRoles(ctx, userData) {
      return new Promise((resolve, reject) => {
        update('/admin/roles', userData)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
